export default __webpack_public_path__ + "static/media/add-point.11d71f67.svg";